// removed by extract-text-webpack-plugin
module.exports = {"marketType":"_3SNzy6hNP_72vmrOlNPpJR","marketText":"_1qdb80VG21tncYourG7ORC","oddsButton":"_3EVjijBb-N7Fi9-5Au8RDD","checked":"ippzDt7P9c5K8Q9m_iLmJ"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/firstDown/css/button.css
// module id = 835
// module chunks = 0